import { ProductUnit } from '@features/products/enums/productUnit'

export const DEMO_INVOICE_UNITS: ProductUnit[] = Object.values(ProductUnit)
